


import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InvitationPasswordForm from '../../components/invitation-password-form';
import LanguageSelect from '../../components/language-select';
import Logo from '../../components/common/logo';
import HelpButton from '../../components/common/help-button';
import { languages, getLanguage } from '../../utils/index';
import { useCommon } from '../../store/common';
import l from '../../lang';
import { Routes } from '../../config/routes';
import { InvitationPasswordActions, InvitationPasswordSelectors } from '../../store/invitation-password';
import '../../pages/pasword-reset/styles.scss';

const InvitationPassword = () => {
  const { changeLanguage } = useCommon();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(InvitationPasswordSelectors.getInvitationPasswordLoading);
  const error = useSelector(InvitationPasswordSelectors.getInvitationPasswordError);
  const errorInfo = useSelector(InvitationPasswordSelectors.getInvitationPasswordErrorInfo);
  const success = useSelector(InvitationPasswordSelectors.getInvitationPasswordSuccess);

  useEffect(() => {
    if (success) {
      history.push(Routes.LOGIN, { invitationAccepted: true });
    }
  }, [success, history]);

  /**
   * @param {string} password
   * @param {string} token
   */
  const handleSubmit = (password, token) => {
    dispatch(InvitationPasswordActions.confirmInvitationPassword(password, token));
  };

  return (
    <div className="password-reset">
      <div className="home-content">
        <div className="help-button-container">
          <HelpButton />
        </div>
        <div className="form-content">
          <div className="language-container">
            <LanguageSelect languages={languages} selected={getLanguage()} onClick={changeLanguage} />
          </div>
          <Logo size="xl" type="vertical" />
          <InvitationPasswordForm
            loading={loading}
            error={error}
            errorInfo={errorInfo}
            fnSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default InvitationPassword;
